<main class="partner-detail-page">
  <div class="partner-detail-page__header">
    <div class="top-row">
      <button type="button" class="back-btn" [attr.aria-label]="'partners.backAria' | translate" (click)="goBack()">
        <sz-icon name="arrow-back" [size]="20" />
      </button>
      <sz-brand-block [compact]="true" />
    </div>

    @if (partner; as p) {
      <img class="partner-detail-page__logo" [src]="p.logoSrc" [alt]="p.name" />
      <sz-button variant="primary" [fullWidth]="true" (click)="openSite()">
        {{ 'partners.viewOffer' | translate }}
      </sz-button>
    }
  </div>

  @if (partner; as p) {
    <div class="partner-detail-page__scroll">
      <div class="partner-detail-page__about">
        <p>{{ 'partners.' + p.id + '.about1' | translate }}</p>
        <p>{{ 'partners.' + p.id + '.about2' | translate }}</p>
      </div>

      <section class="partner-detail-page__salons">
        <h2 class="partner-detail-page__salons-title">{{ 'partners.salonsHeading' | translate }}</h2>
        <ul class="salon-list">
          @for (salon of p.salons; track salon.address) {
            <li class="salon">
              <span class="salon__city">{{ salon.city }}</span>
              <span class="salon__addr">{{ salon.address }}</span>
            </li>
          }
        </ul>
      </section>
    </div>
  }
</main>
